import * as Components from "./GroupsTableRow.components";
import { tableCells } from "../GroupsTable.config";
import Grid from "components/primitives/Grid";
import { memo, useCallback, useMemo } from "react";
import Mui5 from "components/mui5";
import EventHelpers from "helpers/EventHelpers/EventHelpers";
import { Group } from "contexts/GroupsContext/GroupsContext";
import { useArchivedAthletes } from "providers/ArchivedAthletesProvider";
import difference from "lodash/difference";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import NotePadIcon from "components/IconsStandardized/NotePadIcon/NotePadIcon";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DeleteGroupAction from "./DeleteGroupAction";
import TypographyHighlight from "components/TypographyHighlight";

function GroupsTableRow(props: Group) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const archivedAthleteIds = useArchivedAthletes(true);

  const eventPropagationPreventer = useMemo(
    () => ({
      onClick: EventHelpers.preventDefault,
      onMouseDown: EventHelpers.stopPropagation,
    }),
    []
  );

  const activeMemberIds = useMemo(() => {
    return difference(props.athleteIds, archivedAthleteIds);
  }, [archivedAthleteIds, props.athleteIds]);
  const memberCount = activeMemberIds.length;

  const goToGroupEdit = useCallback(() => {
    navigate(`/groups/${props.id}/edit`);
  }, [navigate, props.id]);

  return (
    <>
      <Mui5.Button size="small" fullWidth variant="text" href={`/groups/${props.id}`}>
        <Grid width="100%" container component={Components.TableRow} alignItems="center" justifyContent="space-between">
          <Grid {...tableCells.checkbox} {...eventPropagationPreventer}>
            <Components.ColorBlockDiv color={props.colour} />
          </Grid>
          <Grid {...tableCells.name}>
            <TypographyHighlight variant="h4" color="primary" noWrap sx={{ fontWeight: 500 }}>
              {props.name}
            </TypographyHighlight>
            <Typography variant="body1" color="textSecondary" noWrap>
              {t("groups.table_row_group_member", {
                description: props.description,
                count: memberCount,
                context: props.description ? "description" : undefined,
              })}
            </Typography>
          </Grid>
          <Grid {...tableCells.actions} {...eventPropagationPreventer}>
            <Grid container justifyContent="space-around">
              <Grid>
                <IconButton
                  color="primary"
                  title={t("group.all.edit_button_title_text", { groupName: props.name })}
                  aria-label={t("group.all.edit_button_title_text", { groupName: props.name })}
                  onClick={goToGroupEdit}
                >
                  <NotePadIcon color="primary" fontSize="small" />
                </IconButton>
              </Grid>
              <Grid>
                <DeleteGroupAction group={props} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Mui5.Button>
    </>
  );
}

export default memo(GroupsTableRow);
